import { Stack } from '@mui/material'
import { useControls } from '@workwave-tidal/core/controls'
import { useGetNearestColors } from '../hooks/useGetNearestColors.js'
import { Swatch } from './Swatch.js'

export function Content() {
  const {
    controls,
    values: { color, includeContrastText },
  } = useControls({
    color: {
      allowRandomColor: false,
      hidePalette: true,
      hidePicker: false,
      label: 'Color',
      type: 'color',
      value: '#1565c0',
    },
    includeContrastText: {
      label: 'Match contrast text',
      type: 'boolean',
      value: false,
    },
  })

  const colorMatches = useGetNearestColors({
    color,
    includeContrastText,
    limit: 25,
  })

  return (
    <Stack
      sx={{
        gap: 1,
        // ':first-child': { mb: 2 },
      }}
    >
      {controls}

      {colorMatches.map(entry => (
        <Swatch entry={entry} key={entry.path} />
      ))}
    </Stack>
  )
}
